<template>
  <div>
    <section class="subpage-head"><div class="container"><h1>{{ item.id?'Edit':'Create' }} {{ entity }}</h1></div></section>
    <section class="login-reg">
      <div class="container">
        <div class="log-box main">
          <form class="gen-form" v-on:submit.prevent="saveProfile">
            <div class="form-row">
              <label>Username</label>
              <input type="text" :readonly="item.id" v-model="item.username" />
            </div>
            <div class="form-row">
              <label>Email Address</label>
              <input type="email" v-model="item.email" />
            </div>
            <div class="form-row split">
              <div>
                <label>First Name</label>
                <input type="text" v-model="item.firstname" />
              </div>
              <div>
                <label>Last Name</label>
                <input type="text" v-model="item.lastname" />
              </div>
            </div>
            <div class="form-row split">
              <div>
                <label>Password</label>
                <input type="password" v-model="item.newPassword" />
              </div>
              <div>
                <label>Confirm Password</label>
                <input type="password" v-model="item.confirmPassword" />
              </div>
            </div>
            <div class="form-row split">
              <div>
                <br />
                <label class="checkbox">
                  <input type="checkbox" v-model="item.admin" /><em></em>
                  Administrator
                </label>
              </div>
              <div>
                <br />
                <label class="checkbox">
                  <input type="checkbox" v-model="item.hasPpatt" /><em></em>
                  Has access to PPATT
                </label>                
              </div>
            </div>
            <div class="form-row form-row-photo">
              <label>Photo</label>
              <img v-if="item.media" :src="photoLinkR(item.media, 256, 256, 'Fit')" alt="" />
              <button v-if="item.media" class="del-file" v-on:click.prevent="removePhoto">Remove photo</button>
              <input v-else type="file" ref="photoUpload" />
            </div>
            <div class="form-act">
              <button class="lbtn">{{ item.id?'Update':'Create' }}</button>
            </div>
          </form>
        </div>
        <user-package v-if="item.id" :item="item" v-on:update="$emit('update')" v-on:save="$emit('save')" />
      </div>
    </section>
    
  </div>
      
</template>
<script>
import api from './api';
export default {
  props: ["item", "entity"],
  data: ()=>({
    freqOpt: [
      "Daily", "Twice a week", "Weekly",
    ],
    yearsOpt: [
      "1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
      "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
      "21", "22", "23", "24", "25", "26", "27", "28", "29", "30",
      "31", "32", "33", "34", "35", "36", "37", "38", "39", "40",
      "41", "42", "43", "44", "45", "46", "47", "48", "49", "50",
      "51", "52", "53", "54", "55", "56", "57", "58", "59", "60",
      "61", "62", "63", "64", "65", "66", "67", "68", "69", "70",
      "71", "72", "73", "74", "75", "76", "77", "78", "79", "80",
    ],
    genderOpt: [
      "Male", "Female", 
    ],
    levelOpt: [
      "Lolita’s Legacy Educator", "Lolita’s Disciple", "Lolita’s Legacy Graduate", "Lolita’s Legacy Student", "Elder Master Teacher",
    ],
  }),
  methods: {
    async saveProfile() {
      var item=JSON.parse(JSON.stringify(this.item));
      delete item.password;
      item.media=item.media && item.media.id;
      delete item.activePayment;
      delete item.lastPayment;
      delete item.package;
      if (this.item.id)
        await api.update(this.entity, this.item.id, item);
      else {
        item.active="Yes";
        item.currency="USD";
        var id=(await api.create(this.entity, item)).id;
        item.id=id;
      }
      if (this.$refs.photoUpload && this.$refs.photoUpload.files[0]) {
        await this.uploadMedia(this.$refs.photoUpload.files[0]);
        await api.update(this.entity, item.id, {media: this.item.media});
      }
      this.$emit("save");
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    photoLinkR(media, width, height, mode) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return '/api/Media/'+media.id+'/resize?w='+width+"&h="+height+"&m="+mode;
    },
    async uploadMedia(file, field) {
      var result=await api.create("Media", {store: 1});
      if (result.id) {
        await api.upload("Media", result.id, file);
      }
      var media=(await api.get("Media", result.id)).item;
      this.$set(this.item, field || "media", media);
    },
    async removePhoto() {
      this.$set(this.item, "media", null);
    },
  },
  created() {
  },
}
</script>
